import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";

function GuestRoutes() {
  const {user} = useAuth();

  return !user ? <Outlet /> : <Navigate to="/"  replace />;
}

export default GuestRoutes